import PinIcon from "@/assets/icons/pin.svg";
import PlusLogoLight from "@/assets/icons/plus-logo-dark.svg";
import CustomViewDialog from "@/components/customViews/CustomViewDialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import SmartLabel from "@/domain/enums/SmartLabel";
import useGetNavbarData from "@/hooks/useGetNavbarData";
import { customViewRootUrl, smartLabelRootUrl } from "@/router/routes";
import { PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import CustomViewItem from "./CustomViewItem";
import CustomViewsAccordion from "./CustomViewsAccordion";
import GeneralSectionAccordion from "./GeneralSectionAccordion";
import SectionTitle from "./SectionTitle";
import SmartLabelItem from "./SmartLabelItem";

const Navbar = () => {
    const { t } = useTranslation();
    const { navbarData } = useGetNavbarData();

    return (
        <nav className="mb-4 w-[120px] shrink-0 rounded-2xl bg-white py-4">
            <ScrollArea className="h-full" variant="ghost">
                <div className="flex h-full flex-col justify-between gap-6 px-1">
                    <div className="flex h-full flex-col gap-6">
                        <div>
                            <SectionTitle
                                icon={PlusLogoLight}
                                iconSize="medium"
                                label={t("navbar.smartLabels.title")}
                                variant="highlight"
                            />
                            <ul className="mt-3 flex flex-col gap-1">
                                {navbarData?.smartlabelNavItems?.map(
                                    (smartLabel) => (
                                        <li key={smartLabel.id}>
                                            <SmartLabelItem
                                                count={smartLabel.itemCount}
                                                id={smartLabel.id as SmartLabel}
                                                label={
                                                    smartLabel.menuInfo?.title
                                                }
                                                to={`/${smartLabelRootUrl}/${smartLabel.id}`}
                                            />
                                        </li>
                                    ),
                                )}
                            </ul>
                        </div>
                        <GeneralSectionAccordion
                            items={navbarData?.generalNavItems || []}
                        />
                    </div>
                    <div>
                        <div className="mb-2 flex items-center justify-between gap-1">
                            <SectionTitle
                                icon={PinIcon}
                                label={t("navbar.customViews.title")}
                            />
                            <CustomViewDialog
                                trigger={
                                    <PlusIcon className="h-5.5 w-5.5 rounded-full p-1 transition-colors hover:bg-surface-activeFg" />
                                }
                            />
                        </div>
                        <ul className="mt-1 flex flex-col gap-1">
                            {navbarData?.customviewsNavItems
                                ?.filter((view) => view.isFavorite)
                                .map((view) => (
                                    <CustomViewItem
                                        key={view.id}
                                        icon={view.menuInfo?.icon as string}
                                        label={view.menuInfo?.title}
                                        to={`/${customViewRootUrl}/${view.id}`}
                                    />
                                ))}
                        </ul>
                        {navbarData?.customviewsNavItems && (
                            <CustomViewsAccordion
                                customviewsNavItems={navbarData?.customviewsNavItems.filter(
                                    (view) => !view.isFavorite,
                                )}
                            />
                        )}
                    </div>
                </div>
            </ScrollArea>
        </nav>
    );
};

export default Navbar;
